import { useEffect, useRef } from 'react'

/*
  Recarrega quando a aba volta a aparecer.

  Parte do cadastro no Cutilei Pay se completa fora daqui — numa página do Asaas, que abre
  em outra aba — e nada avisa esta quando termina. Lida só na montagem, a tela continua
  mostrando a situação de antes do envio até alguém recarregar a página na mão.

  São dois eventos porque um não cobre o outro: `visibilitychange` pega a volta para esta
  aba, e o `focus` da janela pega a volta para o navegador inteiro, que em janela separada
  não muda a visibilidade de aba nenhuma.

  Uso:

    useRefreshOnReturn (getData)

  O que se passa aqui precisa aguentar ser chamado a qualquer momento, inclusive com uma
  consulta anterior em voo: os dois eventos disparam juntos com frequência. A referência
  guarda sempre a última função recebida, para que quem usa o hook não precise envolver a
  sua num `useCallback` só para não reassinar os ouvintes a cada render.
*/
export default function useRefreshOnReturn (onReturn) {
  const callback = useRef (onReturn)

  callback.current = onReturn

  useEffect (() => {
    const refresh = () => {
      if (document.visibilityState === 'hidden') return

      callback.current ()
    }

    document.addEventListener ('visibilitychange', refresh)
    window.addEventListener ('focus', refresh)

    return () => {
      document.removeEventListener ('visibilitychange', refresh)
      window.removeEventListener ('focus', refresh)
    }
  }, [])
}
